import React from "react";
import classNames from "classnames";

import Typography from "@/components/Typography";
import { formatOnAir } from "@/helpers/formatOnAir";
import ArchiveIcon from "@/icons/archive-20.svg";
import TwitchIcon from "@/icons/twitch.svg";
import LinkOutIcon from "@/icons/link-out.svg";
import { getScheduleTime } from "@/helpers/getScheduleTime";
import { PodcastType } from "@/helpers/pageHelpers/Common/interface";

import styles from "./PodcastSchedule.module.scss";

export const PodcastSchedule: React.FC<{
  schedule?: { startTime: string; endTime: string };
  podcastType: PodcastType;
}> = ({ schedule, podcastType }) => {
  const isScheduleTimeAvailable = !!schedule?.startTime && !!schedule?.endTime;
  const isScheduleHidden =
    !(podcastType === PodcastType.Archived) && !isScheduleTimeAvailable;
  const startTime = new Date(schedule?.startTime);
  const endTime = new Date(schedule?.endTime);

  const renderContent = () => {
    switch (podcastType) {
      case PodcastType.Live:
        return (
          <span className={styles.onAir}>
            {formatOnAir(schedule.startTime)}: {getScheduleTime(startTime)}-
            {getScheduleTime(endTime)}
          </span>
        );
      case PodcastType.Archived:
        return (
          <>
            <ArchiveIcon />
            <span className={styles.archive}>Audycja archiwalna</span>
          </>
        );
      case PodcastType.Twitch:
        return (
          <>
            <TwitchIcon />
            <span>Oglądaj na Twitch.tv</span>
            <a href="https://www.twitch.tv/newonce_">
              <LinkOutIcon className={styles.linkOutIcon} />
            </a>
          </>
        );
    }
  };

  return (
    <div
      className={classNames(styles.wrapper, isScheduleHidden && styles.hidden)}
    >
      <Typography className={styles.label}>{renderContent()}</Typography>
    </div>
  );
};

export default PodcastSchedule;
